import { Factory } from "./../../core/factory";

import { BasePolygonMark } from "./base-polygon";

import { registerPolygonAnimation } from "../../animation/config";

import { createPolygon, registerPolygon, registerShadowRoot } from "../../vrender-bridge";

export class PolygonMark extends BasePolygonMark {
    constructor() {
        super(...arguments), this.type = PolygonMark.type;
    }
    _getDefaultStyle() {
        return Object.assign(Object.assign({}, super._getDefaultStyle()), {
            lineWidth: 0
        });
    }
}

PolygonMark.type = "polygon";

export const registerPolygonMark = () => {
    Factory.registerMark(PolygonMark.type, PolygonMark), registerShadowRoot(), registerPolygon(), 
    registerPolygonAnimation(), Factory.registerGraphicComponent("polygon", createPolygon);
};
//# sourceMappingURL=polygon.js.map
